<template>
  <el-dialog
    title="帖子选择"
    :visible.sync="visible"
    width="752px"
    :before-close="handleClose">
    <div class="condition">
      <div class="container">
        <div class="left">
          帖子标题
        </div>
        <div class="center">
          <el-input v-model.trim="postTitle" :maxlength="20" ></el-input>
        </div>
        <div class="right">
          <el-button type="primary" @click="submit">搜索</el-button>
        </div>
      </div>
    </div>
    <div class="select-post">
      <ul class="post-list">
        <li v-for="post in posts" :key="post.id" class="item">
          <post-card :post="post" @selected="selectedPost(post)"></post-card>
        </li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :disabled="!hasSelected" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {fetchPostList} from '@/api/post/post';
import PostCard from './post-card';

export default {
  components: {
    PostCard
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    }
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  computed: {
    hasSelected() {
      const exists = this.posts.find(item => !!item.selected);
      return !!exists;
    }
  },
  data () {
    return {
      postTitle: '',
      posts: [],
    }
  },
  methods: {
    loadImage(e) {
      const width = e.target.width;
      const height = e.target.height;
      if (width > height) {
        e.target.style.width = 'auto';
        e.target.style.height = '100%';
      } else {
        e.target.style.height = 'auto';
        e.target.style.width = '100%';
      }
    },
    handleClose() {
      console.log('close');
      this.$emit('close');
    },
    handleSubmit () {
      const post = this.posts.find(item => !!item.selected);
      if (!post) {
        return;
      }

      this.$emit('submit', post);
    },
    selectedPost (post) {
      this.posts.forEach(item => {
        item.selected = (item.id === post.id && !item.selected);
      });
    },
    async init () {
      let params = {
          // circleId: 1,
        current: 1,
        size: 100
      }

      const response = await this.requestWrapper(fetchPostList, params)
      this.posts = response.data.records.map(item => {
        return {
          ...item,
          selected: false
        }
      });
      console.log(response);
    }
  },
  created() {
    this.init();
  }
}
</script>


<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  li {
    list-style: none;
  }
}
::-webkit-scrollbar {
  display: none;
}

.condition {
  .container {
    display: flex;
    align-items: center;
    text-align: center;
    .left {
      margin-right: 6px;
    }
    .center {
      margin-right: 6px;
    }
  }
}
.select-post {
  height: 500px;
  overflow: auto;
  margin-top: 16px;
  .post-list {
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-right: 14px;
      padding-bottom: 16px;
    }
  }
}
</style>
